import styled from "styled-components";
import { ConversationTypeEnum } from "@coxauto-ui/cxm/communications/interfaces";

const StyledGenerativeAIPromptCard = styled.div`
  padding: 16px;
  background-color: #ebf6ff;
  border: 1px solid #cacfd9;

  .generative-ai-prompt-card-user-display-name {
    font-style: italic;
  }
`;

interface GenerativeAIPromptCardProps {
  activeListTab: ConversationTypeEnum;
  index: number;
  prompt: string;
  userDisplayName: string;
}

export function GenerativeAIPromptCard({
  activeListTab,
  index,
  prompt,
  userDisplayName
}: GenerativeAIPromptCardProps) {
  return (
    <StyledGenerativeAIPromptCard>
      <div
        className="generative-ai-prompt-card-user-display-name"
        data-testid={`generative-ai-prompt-card-user-display-name-${activeListTab}-${index}`}
        id={`generative-ai-prompt-card-user-display-name-${activeListTab}-${index}`}
      >
        {userDisplayName || "user"}
      </div>
      <div
        className="generative-ai-prompt-card-prompt"
        data-testid={`generative-ai-prompt-card-prompt-${activeListTab}-${index}`}
        id={`generative-ai-prompt-card-prompt-${activeListTab}-${index}`}
      >
        {prompt}
      </div>
    </StyledGenerativeAIPromptCard>
  );
}
